import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import { BackButton } from '../../components/ui/Button';
import { OptionCard, TipBox, PageHeader } from '../../components/ui';

const videoOptions = [
  {
    id: 'subtitle-generator',
    icon: 'mdi:subtitles',
    iconColor: '#EC4899',
    iconBgColor: '#FCE7F3',
    title: 'AI 字幕生成器',
    subtitle: 'Whisper GPU',
    description: '使用 Whisper GPU 精確辨識字幕，支援編輯和自訂樣式匯出',
    path: '/templates/subtitle-generator'
  },
  {
    id: 'ai-edit',
    icon: 'mdi:movie-edit',
    iconColor: '#8B5CF6',
    iconBgColor: '#EDE9FE',
    title: 'AI Clip Editor',
    subtitle: 'Reference Creator',
    description: 'Reference creator style from video links and generate short video scripts with AI',
    path: '/templates/creator-to-script/ai-edit'
  },
  {
    id: 'from-scratch',
    icon: 'mdi:video-plus',
    iconColor: '#10B981',
    iconBgColor: '#D1FAE5',
    title: 'Start from Scratch',
    subtitle: 'Original Creation',
    description: 'Create your own video content from scratch with AI assistance',
    path: '/templates/creator-to-script/from-scratch',
    comingSoon: true
  }
];

function CreatorToScriptSelect() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)]">
      <div className="flex h-screen">
        <Sidebar activePage="home" />

        <div className="flex-1 overflow-y-auto bg-gray-50">
          {/* Back Button */}
          <BackButton
            onClick={() => navigate('/home')}
            className="fixed top-6 left-[280px] z-[100]"
          >
            Back to Home
          </BackButton>

          <div className="max-w-[900px] mx-auto px-8 py-16">
            {/* Header */}
            <PageHeader
              badge="Video Script"
              badgeIcon="mdi:video"
              title="Choose Your Approach"
              subtitle="Select how you want to create your video content"
            />

            {/* Options Grid */}
            <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-4">
              {videoOptions.map((option) => (
                <OptionCard
                  key={option.id}
                  icon={option.icon}
                  iconColor={option.iconColor}
                  iconBgColor={option.iconBgColor}
                  title={option.title}
                  subtitle={option.subtitle}
                  description={option.description}
                  comingSoon={option.comingSoon}
                  onClick={() => navigate(option.path)}
                />
              ))}
            </div>

            {/* Quick Tips */}
            <TipBox className="mt-8">
              <strong>AI 字幕生成器</strong> 使用 Whisper GPU 提供精確時間戳（0.01秒精度）的語音辨識。
              <strong>AI Clip Editor</strong> 分析創作者風格並生成影片腳本。
              <strong>Start from Scratch</strong> 從零開始創作原創內容。
            </TipBox>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreatorToScriptSelect;
